module.exports = __webpack_public_path__ + "img/2c.82721d6f.png";